export function getOddsInCent(odd) {
	let oddString = odd + "";
	let natural = 0;
	let decimal = 0;
	let divChar = "";
	let oddCent = 0;
	if (oddString.indexOf('.') > 0) {
		divChar = ".";
	}
	else if (oddString.indexOf(',') > 0) {
		divChar = ",";
	}
	natural = oddString.split(divChar)[0];
	decimal = oddString.split(divChar)[1];
	if (decimal == null) {
		oddCent = natural;
	}
	else{
		if (decimal.length === 1) {
			decimal = decimal + "0";
		}
		oddCent = natural + decimal;
	}
	

	return parseInt(oddCent, 10);
}
